import React, { FunctionComponent } from 'react';
import SendToSalespersonButton from './SendToSalespersonButton';
import PresentToCustomerMenuButton from './PresentToCustomerMenuButton';
import { SendButtonProps } from './types';
import { useFniPresent } from '../../../hooks/useFniPresent';

const SendButton: FunctionComponent<SendButtonProps> = props => {
  const { isFinanceOffersTab, dealer, currentUser } = props;

  const isFniPresentFlowEnabled = useFniPresent({
    currentUser,
    dealer,
    ignoreQueryParam: true,
  });

  const displayFniPresentButton = isFniPresentFlowEnabled && isFinanceOffersTab;

  return displayFniPresentButton ? (
    <PresentToCustomerMenuButton {...props} />
  ) : (
    <SendToSalespersonButton {...props} />
  );
};

export default SendButton;
